// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/site." + "eb3894bcef713184e09c" + ".min.css";
};